const BASE_URL = 'https://openmind-api.vercel.app/9-1/';

export default BASE_URL;
